import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {useDropzone} from 'react-dropzone';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import ImageIcon from '@material-ui/icons/Image';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const previewWidth = 640;
const previewHeight = 360;

const useStyles = makeStyles({
  text: {
    margin: '2rem',
  },
  empty: {
    fontSize: '2rem',
    height: previewHeight,
    width: previewWidth,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-around',
    borderStyle: 'dashed',
    borderWidth: 1,
    borderColor: '#999',
    backgroundColor: '#eee',
  },
  preview: {
    width: previewWidth,
    height: previewHeight,
    objectFit: 'cover',
  }
});

const ImageDropZone = ({instructions, imageUrl: initialImageUrl, setImageFile, clearImageUrl}) => {
  const classes = useStyles();

  const [imageUrl, setImageUrl] = useState(initialImageUrl);
  const [preview, setPreview] = useState();

  const onDrop = useCallback(async files => {
    if (files.length < 1) return;  // rejected drop, eg unsupported file type
    const objectUrl = URL.createObjectURL(files[0]);
    setPreview(objectUrl);
    setImageFile(files[0]);
    setImageUrl(objectUrl);
  }, [setImageFile]);

  const {getRootProps, getInputProps} = useDropzone({
    accept: 'image/*',
    onDrop,
  });

  useEffect(() => () => {
    // Make sure to revoke the data uris to avoid memory leaks
    URL.revokeObjectURL(preview);
  }, [preview]);

  const onDelete = () => {
    setImageUrl();
    setPreview();
    setImageFile();
    clearImageUrl();
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={8} {...getRootProps({style: {lineHeight: 0}})}>
        <input {...getInputProps()} />
        {imageUrl ?
          <img src={imageUrl} className={classes.preview} alt="banner preview"/> :
          <div className={classes.empty}>
            <p>Drop your banner image here</p>
            <ImageIcon fontSize="large"/>
            <p>or click to select.</p>
          </div>
        }
      </Grid>
      <Grid item container xs={4} alignContent="space-between">
        <Grid item xs={12}>
          <IconButton color="primary" aria-label="delete image" component="span" onClick={onDelete}>
            <DeleteIcon/>
          </IconButton>
        </Grid>
        <Grid item xs={12}>
          {instructions.map((p,i) => <Typography key={i} paragraph className={classes.text}>{p}</Typography>)}
        </Grid>
      </Grid>
    </Grid>
  );
};

ImageDropZone.propTypes = {
  imageUrl: PropTypes.string,
  setImageFile: PropTypes.func.isRequired,
  clearImageUrl: PropTypes.func.isRequired,
  instructions: PropTypes.array.isRequired,
};

export default ImageDropZone;
